import React from "react";
import { Link } from "react-router-dom";

const ProfileLink = ({ filter, navLinkClicked, children, centered = 0 }) =>
  centered ? (
    <Link
      onClick={(e) => {
        console.log("navlink clickedksld fl");
        navLinkClicked();
      }}
      to={`${filter}`}
      className="notification"
    >
      {children}
    </Link>
  ) : (
    <Link
      onClick={(e) => {
        console.log("navlink clickedksld fl");
        navLinkClicked();
      }}
      to={`${filter}`}
    >
      {children}
    </Link>
  );

export default ProfileLink;
